import { ISameCaseEasyUpdateModel } from './ISameCaseEasyUpdateModel';
import { SameCaseEasyUpdate } from './SameCaseEasyUpdate';
import { useParams } from 'react-router-dom';

export interface ISameCaseEasyUpdatePageProps {}

export function SameCaseEasyUpdatePage(props: ISameCaseEasyUpdatePageProps) {
    const { sameCaseGuid } = useParams();

    return (
        <SameCaseEasyUpdate
            isRoot
            sameCaseGuid={sameCaseGuid}
        />
    );
}
